import { Lang } from "@/utils/lang.enum";

export class ClientMailingListOutDTO {
  emails!: string[];
  pointOfSaleName!: string;
  lang!: Lang;
}
